import { useContext } from 'react';

import { AuthContext } from '../auth';

export const useKeycloakAuth = () => useContext(AuthContext);
